
import cfImage from '@/utils/cfImage'

const IMG_BASE = 'https://blog.flightgorilla.com/wp-content/uploads/2023/11'

export default {
  methods: {
    cfImage,
    prefillSearch (payload) {
      this.$store.commit('setSearchFormPrefill', payload)
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  },
  data () {
    return {
      smarterCards: [
        { key: 'routes', icon: '🌍' },
        { key: 'booking', icon: '📞' },
        { key: 'fees', icon: '💸' },
        { key: 'budget', icon: '🎒' }
      ],
      adventureCards: [
        { key: 'oneway', icon: '➡️' },
        { key: 'return', icon: '↩️' },
        { key: 'group', icon: '👥' }
      ],
      destinations: [
        { code: 'NRT', name: 'Tokyo', countryKey: 'japan', img: `${IMG_BASE}/tokyo.jpg` },
        { code: 'DPS', name: 'Bali', countryKey: 'indonesia', img: `${IMG_BASE}/bali.jpg` },
        { code: 'CPT', name: 'Cape Town', countryKey: 'south_africa', img: `${IMG_BASE}/cape-town.jpg` },
        { code: 'JFK', name: 'New York', countryKey: 'united_states', img: `${IMG_BASE}/new-york.jpg` },
        { code: 'DXB', name: 'Dubai', countryKey: 'uae', img: `${IMG_BASE}/dubai.jpg` },
        { code: 'BKK', name: 'Bangkok', countryKey: 'thailand', img: `${IMG_BASE}/bangkok.jpg` },
        { code: 'SYD', name: 'Sydney', countryKey: 'australia', img: `${IMG_BASE}/sydney.jpg` },
        { code: 'SIN', name: 'Singapore', countryKey: 'singapore', img: `${IMG_BASE}/singapore.jpg` },
        { code: 'GIG', name: 'Rio de Janeiro', countryKey: 'brazil', img: `${IMG_BASE}/rio-de-janeiro.jpg` },
        { code: 'LAX', name: 'Los Angeles', countryKey: 'united_states', img: `${IMG_BASE}/los-angeles.jpg` },
        { code: 'HKG', name: 'Hong Kong', countryKey: 'hong_kong', img: `${IMG_BASE}/hong-kong.jpg` },
        { code: 'CUN', name: 'Cancun', countryKey: 'mexico', img: `${IMG_BASE}/cancun.jpg` }
      ],
      routes: [
        { from: 'LHR', to: 'NRT', fromName: 'London', toName: 'Tokyo', img: `${IMG_BASE}/tokyo.jpg` },
        { from: 'LHR', to: 'DPS', fromName: 'London', toName: 'Bali', img: `${IMG_BASE}/bali.jpg` },
        { from: 'JFK', to: 'SYD', fromName: 'New York', toName: 'Sydney', img: `${IMG_BASE}/sydney.jpg` },
        { from: 'LHR', to: 'CPT', fromName: 'London', toName: 'Cape Town', img: `${IMG_BASE}/cape-town.jpg` },
        { from: 'JFK', to: 'DXB', fromName: 'New York', toName: 'Dubai', img: `${IMG_BASE}/dubai.jpg` },
        { from: 'LHR', to: 'HKG', fromName: 'London', toName: 'Hong Kong', img: `${IMG_BASE}/hong-kong.jpg` },
        { from: 'CDG', to: 'JFK', fromName: 'Paris', toName: 'New York', img: `${IMG_BASE}/new-york.jpg` },
        { from: 'LHR', to: 'GIG', fromName: 'London', toName: 'Rio de Janeiro', img: `${IMG_BASE}/rio-de-janeiro.jpg` },
        { from: 'LAX', to: 'SIN', fromName: 'Los Angeles', toName: 'Singapore', img: `${IMG_BASE}/singapore.jpg` }
      ]
    }
  }
}
